import React, { Component } from 'react'
import { Player, ControlBar } from 'video-react'

import BackgroundCover from 'background-cover'

import 'video-react/dist/video-react.css'
import styles from './VideoCover.module.scss'

class VideoCover extends Component {
	player;
	componentDidMount() {
		// this.player.playbackRate = 0.1;

		let video = this.player.video.video
		let videoContainer = this.player.manager.rootElement
		video.addEventListener('loadedmetadata', () => {
			BackgroundCover(video, videoContainer)
		})
	}
	render () {
		return (
			<Player {...this.props}
			        ref={el => this.player = el}
					fluid={false}
					width="100%"
					height="100%"
					autoPlay
					playsInline
					loop
			        muted
			        className={styles.player}>
			    <ControlBar disableCompletely />
			</Player>
		)
	}
}

export default VideoCover


// WEBPACK FOOTER //
// ./src/components/VideoCover/VideoCover.js